import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const HeaderWrapperWithPadding = styled(HeaderWrapper)`
  padding: 60px 0 40px 0;
`;
